import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import clock from "../assets/Vector (1).png";
import "./visaPrice.css";

import flagimg1 from "../assets/Rectangle 610.png"

const mockVisaData = [
  {
    id: 1,
    continent: "Europe",
    country: "France",
    days: 90,
    price: 8000,
    rejectionRate: "5%",
    flagUrl: flagimg1
  },
  {
    id: 2,
    continent: "Asia",
    country: "Japan",
    days: 30,
    price: 5000,
    rejectionRate: "48%",
    flagUrl: flagimg1
  },
  {
    id: 3,
    continent: "Europe",
    country: "Portugal",
    days: 30,
    price: 5000,
    rejectionRate: "8%",
    flagUrl: "/japan-flag.png"
  },
  {
    id: 4,
    continent: "Asia",
    country: "Japan",
    days: 30,
    price: 5000,
    rejectionRate: "8%",
    flagUrl: "/japan-flag.png"
  },
  {
    id: 5,
    continent: "Asia",
    country: "Tengen",
    days: 30,
    price: 5000,
    rejectionRate: "8%",
    flagUrl: "/japan-flag.png"
  },
  {
    id: 6,
    continent: "Asia",
    country: "Japan",
    days: 30,
    price: 5000,
    rejectionRate: "18%",
    flagUrl: flagimg1
  },

  
];

const getColorByRejectionRate = (rate) => {
  // Convert "XX%" to number
  const rateNum = parseFloat(rate);
  if (rateNum >= 20) return "#FF4444";  // Red
  if (rateNum >= 10) return "#FFB800";  // Yellow
  return "#4CAF50";  // Green
};

const VisaPrice = () => {
  const [visaData, setVisaData] = useState([]);
  const [activeContinent, setActiveContinent] = useState("All");
  const navigate = useNavigate();

  const handleApplyNow = () => {
    navigate("/VisaInfo"); 
  };

  useEffect(() => {
    const fetchVisaData = async () => {
      try {
        const response = await fetch('/api/visas');
        if (!response.ok) throw new Error('Failed to fetch visa data');
        const data = await response.json();
        setVisaData(data);
        // TODO: Remove in production
        console.log('Visa data fetched successfully');
      } catch (error) {
        // TODO: Remove in production
        console.log('Using mock data:', error);
        setVisaData(mockVisaData);
      }
    };

    fetchVisaData();
  }, []);

  const filterVisaData = () => {
    if (activeContinent === "All") return visaData;
    return visaData.filter(visa => visa.continent === activeContinent);
  };

  return (
    <div style={{padding:'20px',backgroundColor:'#ffffff',border: '1px solid #541C9C',borderRadius:'30px'}}>
      <div className="visacategories">
        {["All", "Europe", "Asia", "Others"].map((continent) => (
          <div
            key={continent}
            onClick={() => setActiveContinent(continent)}
            className={`continent-filter${activeContinent === continent ? '-active' : ''}`}
          >
            {continent}
          </div>
        ))}
      </div>
      <div className="visapricedata">
        {filterVisaData().map((visa) => (
          <div key={visa.id} className="visa-item" onClick={handleApplyNow}>
            <div className="visa-flag">
              <img src={visa.flagUrl} />
            </div>
            <div style={{padding:'15px'}}>
              <div className="visa-details-row1">
                <div style={{fontWeight:'700',fontSize:'18px'}}>{visa.country}</div>
                <div><span><img style={{marginRight:'5px'}}src={clock}></img></span>{visa.days} Days</div>
              </div>
              <div className="visa-price">₹{visa.price}</div>
              <div>Rejection Rate: <span style={{color: getColorByRejectionRate(visa.rejectionRate)}}>{visa.rejectionRate}</span></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VisaPrice;